import React, { useState, useEffect, useCallback } from "react";
import {
  Container, Grid, Paper, Typography, TextField, Table, TableBody, TableCell,
  TableHead, TableRow, Chip, LinearProgress, makeStyles
} from "@material-ui/core";
import { getAgentPerformance } from "../../services/api.new-features";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  paper: { padding: theme.spacing(2) },
  statCard: { padding: theme.spacing(2), textAlign: "center" },
  online: { color: "#4caf50", fontWeight: "bold" },
  offline: { color: "#9e9e9e" },
}));

const AgentPerformance = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAgentPerformance({ startDate, endDate });
      setData(res.data);
    } catch (e) { toast.error("Erro ao carregar desempenho"); }
    setLoading(false);
  }, [startDate, endDate]);

  useEffect(() => { load(); }, [load]);

  const totals = data.reduce((acc, a) => ({
    tickets: acc.tickets + a.totalTickets,
    resolved: acc.resolved + a.resolvedTickets,
    open: acc.open + a.openTickets,
    messages: acc.messages + a.messagesSent,
    breaches: acc.breaches + a.slaBreaches
  }), { tickets: 0, resolved: 0, open: 0, messages: 0, breaches: 0 });

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Typography variant="h5" gutterBottom>Desempenho dos Agentes</Typography>

      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        <Grid item xs={12} sm={3}>
          <TextField fullWidth type="date" label="Data Início" InputLabelProps={{ shrink: true }}
            value={startDate} onChange={e => setStartDate(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField fullWidth type="date" label="Data Fim" InputLabelProps={{ shrink: true }}
            value={endDate} onChange={e => setEndDate(e.target.value)} />
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        {[
          { label: "Total Tickets", value: totals.tickets },
          { label: "Resolvidos", value: totals.resolved },
          { label: "Em Aberto", value: totals.open },
          { label: "Mensagens Enviadas", value: totals.messages },
          { label: "Violações SLA", value: totals.breaches }
        ].map((s, i) => (
          <Grid item xs={6} sm={2} key={i}>
            <Paper className={classes.statCard}>
              <Typography variant="h4">{s.value}</Typography>
              <Typography variant="caption">{s.label}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {loading && <LinearProgress />}

      <Paper className={classes.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Agente</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Tickets</TableCell>
              <TableCell align="center">Resolvidos</TableCell>
              <TableCell align="center">Em Aberto</TableCell>
              <TableCell align="center">Mensagens</TableCell>
              <TableCell align="center">Tempo Resp. Médio</TableCell>
              <TableCell align="center">SLA Violações</TableCell>
              <TableCell align="center">Taxa Resolução</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(agent => (
              <TableRow key={agent.userId}>
                <TableCell>
                  <Typography variant="subtitle2">{agent.name}</Typography>
                  <Typography variant="caption" color="textSecondary">{agent.email}</Typography>
                </TableCell>
                <TableCell>
                  <span className={agent.online ? classes.online : classes.offline}>
                    {agent.online ? "● Online" : "○ Offline"}
                  </span>
                </TableCell>
                <TableCell align="center">{agent.totalTickets}</TableCell>
                <TableCell align="center">{agent.resolvedTickets}</TableCell>
                <TableCell align="center">{agent.openTickets}</TableCell>
                <TableCell align="center">{agent.messagesSent}</TableCell>
                <TableCell align="center">{agent.avgFirstResponseMinutes}min</TableCell>
                <TableCell align="center">
                  <Chip size="small" label={agent.slaBreaches}
                    style={{ backgroundColor: agent.slaBreaches > 0 ? "#f44336" : "#4caf50", color: "#fff" }} />
                </TableCell>
                <TableCell align="center">
                  <Chip size="small" label={`${agent.resolutionRate}%`}
                    style={{ backgroundColor: agent.resolutionRate >= 80 ? "#4caf50" : agent.resolutionRate >= 50 ? "#ff9800" : "#f44336", color: "#fff" }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default AgentPerformance;